import { Component, Input } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { AbntPipe } from '../../../../../shared/pipes/abnt.pipe';
import { TotaisDoDocumento, calcularTotaisDoDocumento } from '../vd-totais/venda-totais.calculo';

/**
 * Seção Tributos - os tributos apurados do documento, nas subseções Cálculo do imposto, Reforma
 * tributária e ICMS DIFAL (a mesma organização da NF-e de saída). Só existe com o cálculo de
 * impostos ligado na configuração do processo; o shell decide.
 *
 * Tudo aqui é LEITURA: a mesma conta de `venda-totais.calculo.ts` que o `salvar()` do shell
 * escreve nos controles `valorIpi`, `valorIcms` e companhia. Getter, e não campo sincronizado:
 * mexeu no item, o próximo ciclo de detecção já lê o valor novo.
 */
@Component({
    selector: 'app-vd-tributos',
    standalone: true,
    imports: [AbntPipe, MatFormFieldModule, MatInputModule, MatIconModule],
    templateUrl: './vd-tributos.component.html',
    styleUrl: './vd-tributos.component.css',
})
export class VdTributosComponent {
    @Input({ required: true }) public form!: FormGroup;

    public get itens(): FormArray {
        return this.form.get('itens') as FormArray;
    }

    /** Recalculado a cada leitura: é barato (dezenas de linhas) e nunca fica velho. */
    public get totais(): TotaisDoDocumento {
        return calcularTotaisDoDocumento(this.itens);
    }
}
